import React, { useState } from 'react';
import { IoMdPersonAdd } from "react-icons/io";
import CustomerList from './CustomerList';
import { Link } from 'react-router-dom';

const CustomerManagement = () => {
  const [tab, setTab] = useState('profile');
  const [activeType, setActiveType] = useState("All customers");

  const orderTypes = ["All customers", "Due customers", "Top customers"];

  return (
    <div className="flex flex-col md:flex-row min-h-screen p-4 relative">
      {/* Filter Buttons */}
      <div className="w-full mb-4">
        <div className="flex flex-wrap justify-center gap-2 md:gap-4">
          {orderTypes.map((type) => (
            <button
              key={type}
              onClick={() => setActiveType(type)}
              className={`px-4 py-2 rounded-full text-sm font-medium ${
                activeType === type ? "bg-[#D3222A] text-white" : "text-primary bg-gray-200"
              }`}
            >
              {type}
            </button>
          ))}
        </div>

        {/* Customer List */}
        <CustomerList />

        {/* Add Customer Floating Button */}
        <Link to="/addcustomer" className="fixed bottom-6 right-6 md:bottom-12 md:right-12 z-50">
          <div className="flex items-center justify-center w-12 h-12 bg-primary rounded-full text-white shadow-lg cursor-pointer hover:bg-[#b71c1c] transition">
            <IoMdPersonAdd className="text-xl" />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default CustomerManagement;
